import React from 'react'
import Title from '../layouts/Title'
import { projectOne, projectTwo, projectThree, projectFour, projectFive, projectSix } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="Custom Sass Admin"
          des="Built a Next.js website using ai to streamline and manage backend operations for an eCommerce platform efficiently."
          src={projectFive}
          gitLink="https://github.com/amitv-code/Gemini"
          liveLink="https://oplex.in"
        />
        <ProjectsCard
          title="BULK IMAGE RESIZER"
          des="Developed an image resizer web app using Streamlit and Python for quick and responsive image processing."
          src={projectOne}
          gitLink="https://github.com/amit-debug01/Image-Resizer"
          liveLink="https://imagee.streamlit.app/"
        />
        <ProjectsCard
          title="Meddey.com"
          des="Developed Meddey.com using shopify, a responsive eCommerce website focused on healthcare products and solutions."
          src={projectTwo}
          gitLink="#"
          liveLink="https://meddey.com"
        />
        <ProjectsCard
          title="MEDDEYGO.COM"
          des="Developed Meddeygo.com using shopify, a responsive, dynamic eCommerce website focused on healthcare products and solutions."
          src={projectThree}
          gitLink="#"
          liveLink="https://meddeygo.com"
        />
        <ProjectsCard
          title="Lead Generation Landing Page"
          des="Built a lead generation landing page using React with email capture, form validation, and responsive design."
          src={projectFour}
          gitLink="https://github.com/amitv-code/Lead_generation"
          liveLink="https://meddey.in"
        />
        <ProjectsCard
          title="SEO & MARKETING"
          des=" Optimized medansh.in collections for SEO and marketing: improved descriptions, alt texts, slugs, and backlinks."
          src={projectSix}
          gitLink="#"
          liveLink="https://medansh.in"
        />
      </div>
    </section>
  );
}

export default Projects